// The built-in, read-only default theme — virtual, never stored, represents
// the stock recipient share page (random background + default palette).
// Picking it on a share is an EXPLICIT opt-out of any theme.
export const DEFAULT_THEME_ID = "__default__"

// Live pointer to whichever theme the user has currently marked is_default
// in the gallery. Shares stamped with this id follow that pointer — if the
// user changes their default theme, every "Account Default" share recolors.
export const ACCOUNT_DEFAULT_ID = "__account__"

export const VIRTUAL_DEFAULT_THEME = {
  _id: DEFAULT_THEME_ID,
  readOnly: true,
  content: {
    name: "System Default",
    background_image: null,
    color_background: "#181818",
    color_text: "#FFFFFF",
    color_primary: "#FF6B00",
  },
}

export const VIRTUAL_ACCOUNT_THEME = {
  _id: ACCOUNT_DEFAULT_ID,
  readOnly: true,
  followAccountDefault: true,
  content: {
    name: "Account Default",
    background_image: null,
    color_background: "#181818",
    color_text: "#FFFFFF",
    color_primary: "#FF6B00",
  },
}

export const isDefaultThemeId = (id) => !id || id === DEFAULT_THEME_ID
export const isAccountDefaultId = (id) => id === ACCOUNT_DEFAULT_ID

// Feature-lock identifiers used by the share-themes module.
//   FEATURE_LOCK_THEMES — gates whether the user can create / edit themes
//   FEATURE_LOCK_MAX_THEMES — `value` param holds the per-user cap
export const FEATURE_LOCK_THEMES = 'custom-themes'
export const FEATURE_LOCK_MAX_THEMES = 'max-share-themes'
